import api from "../utils/api";

const BASE = "/api/admin/currencies";

export async function getCurrencies(params = {}) {
  return (await api.get(BASE, { params })).data;
}

export async function getCurrency(id) {
  return (await api.get(`${BASE}/${id}`)).data;
}

export async function createCurrency(payload) {
  return (await api.post(BASE, payload)).data;
}

export async function updateCurrency(id, payload) {
  return (await api.put(`${BASE}/${id}`, payload)).data;
}

export async function deleteCurrency(id) {
  return (await api.delete(`${BASE}/${id}`)).data;
}
